<template>
  <v-layout wrap v-if="hariLibur">
    <v-flex xs12>
      <m-card title="Detail Hari Libur">
        <v-layout wrap>
          <v-flex xs12 sm7 md8>
            <v-list>
              <v-subheader class="title green--text">Identitas</v-subheader>
              <v-divider></v-divider>
              <m-list-tile-info label="No. Reg" :value="hariLibur.hari_libur_id" />
              <m-list-tile-info label="Nama" :value="hariLibur.nama" />
              <m-list-tile-info label="Surel" :value="hariLibur.email" />
              <v-subheader class="title green--text">Alamat</v-subheader>
              <v-divider></v-divider>
              <m-list-tile-info label="Alamat" :value="hariLibur.alamat" />
            </v-list>
          </v-flex>
        </v-layout>
      </m-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      hariLibur: null,
    }
  },
  computed: {},
  activated() {
    this.load()
  },
  methods: {
    load() {
      this.$store
        .dispatch('hariLibur/detail', {
          id_hariLibur: this.$route.params.hari_libur_id,
          organisasi_id: this.organisasi_id || this.tenant_id,
        })
        .then((res) => {
          this.page = res.data
          this.hariLibur = res.data
        })
        .catch((e) => e)
    },
    close() {
      this.$router.push({
        name: 'hariLibur',
      })
    },
  },
}
</script>
